export const state = () => ({
  searchResults: [],
  searchTerm: '',
  schoolsSelected: [],
  schoolsCompare: [],
  //schoolsList: [],

  // Filters
  filtersSector: [],
  filtersNetwork: [],
  filtersCityCouncilDistrict: [],
  filtersAdmissionType: [],
  filtersSchoolLevel: [],
  filtersCommunitySchools: [],

  // Orders
  orderBy: {
    field: 'name',
    order: true
  }
})

export const mutations = {
  updateSearchResults(state, data) {
    state.searchResults = data
  },
  updateSearchTerm(state, data) {
    state.searchTerm = data
  },
  setSchoolsList(state, data) {
    state.schoolsList = data
  },
  setSchoolSelected(state, data) {
    if (data.length > 4) {
      alert('Max of 4 schools')
      return
    }
    state.schoolsSelected = data
  },
  setSchoolsCompare(state, data) {
    // state.schoolsCompare.push(data)
    state.schoolsCompare = data
  },
  removeSchoolsCompare(state, data) {
    state.schoolsSelected = state.schoolsSelected.filter(
      obj => obj.slugid !== data
    )
  },

  // Ordering
  orderSchools(state, field) {
    state.orderBy.order =
      state.orderBy.field != field ? true : !state.orderBy.order
    state.orderBy.field = field

    if (state.orderBy.order) {
      state.searchResults.sort((a, b) => (a[field] > b[field] ? 1 : -1))
    } else {
      state.searchResults.sort((a, b) => (a[field] > b[field] ? -1 : 1))
    }
  },
  orderSchoolsDefault(state, field) {
    state.searchResults.sort((a, b) => (a[field] > b[field] ? 1 : -1))
    state.orderBy = {
      field: 'name',
      order: true
    }
  },

  // Filters
  selectSchool(state, val) {
    if (state.schoolsSelected.indexOf(val) == -1) {
      state.schoolsSelected.push(val)
    } else {
      state.schoolsSelected.splice(state.schoolsSelected.indexOf(val), 1)
    }
  },

  // Filters
  SET_SECTOR(state, val) {
    if (state.filtersSector.indexOf(val) == -1) {
      state.filtersSector.push(val)
    } else {
      state.filtersSector.splice(state.filtersSector.indexOf(val), 1)
    }
  },
  SET_NETWORK(state, val) {
    if (state.filtersNetwork.indexOf(val) == -1) {
      state.filtersNetwork.push(val)
    } else {
      state.filtersNetwork.splice(state.filtersNetwork.indexOf(val), 1)
    }
  },
  SET_COUNCIL_DISTRICT(state, val) {
    if (state.filtersCityCouncilDistrict.indexOf(val) == -1) {
      state.filtersCityCouncilDistrict.push(val)
    } else {
      state.filtersCityCouncilDistrict.splice(
        state.filtersCityCouncilDistrict.indexOf(val),
        1
      )
    }
  },
  SET_ADMISSION_TYPE(state, val) {
    if (state.filtersAdmissionType.indexOf(val) == -1) {
      state.filtersAdmissionType.push(val)
    } else {
      state.filtersAdmissionType.splice(
        state.filtersAdmissionType.indexOf(val),
        1
      )
    }
  },
  SET_SCHOOL_LEVEL(state, val) {
    if (state.filtersSchoolLevel.indexOf(val) == -1) {
      state.filtersSchoolLevel.push(val)
    } else {
      state.filtersSchoolLevel.splice(state.filtersSchoolLevel.indexOf(val), 1)
    }
  },
  SET_COMMUNITY_SCHOOLS(state, val) {
    if (state.filtersCommunitySchools.indexOf(val) == -1) {
      state.filtersCommunitySchools.push(val)
    } else {
      state.filtersCommunitySchools.splice(
        state.filtersCommunitySchools.indexOf(val),
        1
      )
    }
  }
}

export const getters = {
  getFiltersSelected: state => {
    return [
      ...new Set(
        state.filtersSector.map(res => ({ action: 'filterSector', value: res }))
      ),
      ...new Set(
        state.filtersNetwork.map(res => ({
          action: 'filterNetwork',
          value: res
        }))
      ),
      ...new Set(
        state.filtersCityCouncilDistrict.map(res => ({
          action: 'filterCouncilDistrict',
          value: res
        }))
      ),
      ...new Set(
        state.filtersAdmissionType.map(res => ({
          action: 'filterAdmissionType',
          value: res
        }))
      ),
      ...new Set(
        state.filtersSchoolLevel.map(res => ({
          action: 'filterSchoolLevel',
          value: res
        }))
      ),
      ...new Set(
        state.filtersCommunitySchools.map(res => ({
          action: 'filterCommunitySchools',
          value: res
        }))
      )
    ]
  },
  getSearchResults: state => {
    return state.searchResults
  },
  getSchoolsSelected: state => {
    return state.schoolsSelected
  },
  getSchoolsCompare: state => {
    return state.schoolsCompare
  },
  searchTerm: state => {
    return state.searchTerm
  }
}

export const actions = {
  async searchSchools({ dispatch }) {
    dispatch('updateSchoolsResult')
  },

  clearFiltersSelected({ commit, dispatch }) {
    commit('clearFilters')
    dispatch('updateSchoolsResult')
  },

  filterSector({ commit, dispatch }, val) {
    commit('SET_SECTOR', val)
    dispatch('updateSchoolsResult')
  },

  filterNetwork({ commit, dispatch }, val) {
    commit('SET_NETWORK', val)
    dispatch('updateSchoolsResult')
  },

  filterCouncilDistrict({ commit, dispatch }, val) {
    commit('SET_COUNCIL_DISTRICT', val)
    dispatch('updateSchoolsResult')
  },

  filterAdmissionType({ commit, dispatch }, val) {
    commit('SET_ADMISSION_TYPE', val)
    dispatch('updateSchoolsResult')
  },

  filterSchoolLevel({ commit, dispatch }, val) {
    commit('SET_SCHOOL_LEVEL', val)
    dispatch('updateSchoolsResult')
  },

  filterCommunitySchools({ commit, dispatch }, val) {
    commit('SET_COMMUNITY_SCHOOLS', val)
    dispatch('updateSchoolsResult')
  },

  async updateSchoolsResult({ commit, state, rootState }) {
    let sectors = state.filtersSector
    let networks = state.filtersNetwork
    let cityCouncilDistricts = state.filtersCityCouncilDistrict
    let admissionTypes = state.filtersAdmissionType
    let schoolLevels = state.filtersSchoolLevel
    let communitySchools = state.filtersCommunitySchools

    if (sectors.length == 0) {
      const unfilteredArray = rootState.schools.list.map(a => a.sector)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      sectors = filteredArray
    }

    if (networks.length == 0) {
      const unfilteredArray = rootState.schools.list.map(a => a.network)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      networks = filteredArray
    }

    if (cityCouncilDistricts.length == 0) {
      const unfilteredArray = rootState.schools.list.map(a => a.councilDistrict)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      cityCouncilDistricts = filteredArray
    }

    if (admissionTypes.length == 0) {
      const unfilteredArray = rootState.schools.list.map(a => a.admissionType)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      admissionTypes = filteredArray
    }

    if (schoolLevels.length == 0) {
      const unfilteredArray = rootState.schools.list.map(a => a.schoolLevel)
      const filteredArray = [...new Set(unfilteredArray)].sort()
      schoolLevels = filteredArray
    }

    if (communitySchools.length == 0) {
      const unfilteredArray = rootState.schools.list.map(
        a => a.communitySchools
      )
      const filteredArray = [...new Set(unfilteredArray)].sort()
      communitySchools = filteredArray
    }

    if (state.searchTerm !== '') {
      let searchSchoolsFiltered = await rootState.schools.list.filter(
        obj =>
          sectors.includes(obj.sector) &&
          networks.includes(obj.network) &&
          cityCouncilDistricts.includes(obj.councilDistrict) &&
          admissionTypes.includes(obj.admissionType) &&
          schoolLevels.includes(obj.schoolLevel) &&
          communitySchools.includes(obj.communitySchools) &&
          (obj.displayName
            .toLowerCase()
            .includes(state.searchTerm.toLowerCase()) ||
            obj.zipCode.includes(state.searchTerm))
      )

      if (searchSchoolsFiltered.length === 0) {
        commit('updateSearchResults', rootState.schools.list)
      } else {
        commit('updateSearchResults', searchSchoolsFiltered)
      }
    } else {
      if (
        state.filtersSector.length === 0 &&
        state.filtersNetwork.length === 0 &&
        state.filtersCityCouncilDistrict.length === 0 &&
        state.filtersAdmissionType.length === 0 &&
        state.filtersSchoolLevel.length === 0 &&
        state.filtersCommunitySchools.length === 0 &&
        state.searchTerm === ''
      ) {
        // commit('updateSearchResults', [])
        commit('updateSearchResults', rootState.schools.list)
      } else {
        let searchSchoolsFiltered = await rootState.schools.list.filter(
          obj =>
            sectors.includes(obj.sector) &&
            networks.includes(obj.network) &&
            cityCouncilDistricts.includes(obj.councilDistrict) &&
            admissionTypes.includes(obj.admissionType) &&
            schoolLevels.includes(obj.schoolLevel) &&
            communitySchools.includes(obj.communitySchools)
        )
        commit('updateSearchResults', searchSchoolsFiltered)
      }
    }
  }
}
